import React from 'react';
import { _ } from "@/pages/_app";

const riders = [
  "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/688b5225b5c9f84ece222222_rider-1.png",
  "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/688b5225cca9b460d2c2689d_rider-2.png",
  "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/688b522559a1e0b07d372d4f_rider-3.png",
  "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/688b522577411edaa4f11027_rider-4.png",
  "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/688b5225585107d4c03c9c48_rider-5.png"
];

const UsersSection = () => {
  return (
    <section className="relative z-[7] bg-[#f3e8de] flex justify-center items-center pt-[2.8rem] sm:pt-[7.2rem] pb-[3.2rem] sm:pb-[6rem] top-0">
      <div className="absolute top-0 -translate-y-full w-full h-[4rem] bg-[#f3e8de]"></div>

      <div className="max-w-[1360px] px-10 w-full">
        <div className="flex flex-col justify-center items-center gap-[1rem] sm:gap-[3.2rem]">
          <div className="flex flex-row justify-center items-center">
            {riders.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Rider ${index + 1}`}
                loading="lazy"
                className={`border-2 sm:border-4 border-white rounded-full w-[4rem] sm:w-[100px] h-[4rem] sm:h-[100px] shadow-[0_0_20px_rgba(0,0,0,0.08)] ${index === 0 ? 'ml-0' : '-ml-[1.2rem]'
                  }`}
              />
            ))}
          </div>

          <p className="text-[#191513] text-center font-poppins text-[1.1rem] sm:text-[1.5rem] font-semibold leading-[1.5rem] sm:leading-[1.9rem]">
            {_("users-section_text")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default UsersSection;